import { Api } from '@/api/api.client';
import type { Components } from '@/api/generated/api';

export async function fetchPerformanceAssessmentCountsBySubject(params: {
  schoolClassId: number;
  studentId: number;
  from?: string;
  to?: string;
}): Promise<Components.Schemas.PerformanceAssessmentCountBySubjectDto[]> {
  const res = await Api.Routes.SchoolClass.countsBySubject(params);
  return res.rows;
}

export async function fetchPerformanceAssessmentEvaluationsBySubject(params: {
  schoolClassId: number;
  studentId: number;
  subjectId: number;
  from?: string;
  to?: string;
}): Promise<Components.Schemas.PerformanceAssessmentEvaluationsByAssessmentDto[]> {
  const res = await Api.Routes.SchoolClass.getPerformanceAssessmentEvaluationsBySubject(params);
  return res.rows;
}

export async function fetchPerformanceAssessmentStudentEntryOverviewRows(params: {
  classId: number;
  subjectId: number;
  performanceAssessmentId?: number;
  studentId?: number;
  from?: string;
  to?: string;
}): Promise<Components.Schemas.PerformanceAssessmentStudentEntryOverviewRowDto[]> {
  const res = await Api.Routes.PerformanceAssessmentStudentEntry.retrieveOverview({
    classId: params.classId,
    from: params.from,
    performanceAssessmentId: params.performanceAssessmentId,
    studentId: params.studentId,
    subjectId: params.subjectId,
    to: params.to,
  });
  return res.rows;
}

export async function fetchPerformanceAssessmentEntryById(params: {
  id: number;
}): Promise<Components.Schemas.PerformanceAssessmentEntryDto> {
  const res = await Api.Routes.PerformanceAssessmentEntry.retrieveById({ id: params.id });
  return res.data;
}
